import { Link } from "react-router-dom";
import { TargetDot } from "@/components/Icons";
import ServiceIcon from "@/components/ServiceIcons";
import BookCallButton from "@/components/BookCall";
import Reveal from "@/components/Reveal";
import { lines, mediaUrl, sz, txt, useContent } from "@/content/ContentContext";
import heroBg from "@/assets/hero-bg.jpg";

const screenFills = [62, 48, 55];

const cardIcons = ["RefreshCw", "PackageCheck", "ShieldCheck", "ArrowRightLeft"];

const Hero = () => {
  const c = useContent();
  const h = c.home.hero;
  const bg = h.image ? mediaUrl(h.image) : heroBg;

  return (
    <section className="hero" id="home" style={{ backgroundImage: `url(${bg})` }}>
      <Reveal className="hero-copy" y={22}>
        <h1 className="hero-title" style={sz(h.title1)}>
          {txt(h.title1)}
          <br />
          {txt(h.title2)}{" "}
          <span className="text-green" style={sz(h.titleAccent)}>
            {txt(h.titleAccent)}
          </span>
        </h1>
        <p className="hero-para" style={sz(h.paragraph)}>
          {lines(h.paragraph)}
        </p>
        <BookCallButton className="btn-dark hero-cta" testId="hero-cta" />
        <Link to="/contact" className="alt-contact-link" style={sz(c.global.altContactLabel)} data-testid="hero-alt-contact">
          {txt(c.global.altContactLabel)}
        </Link>
      </Reveal>

      <Reveal className="laptop-screen" aria-hidden="true" delay={0.3} y={14}>
        <div className="screen-status">
          <span className="status-ring">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 12.5l3.2 3.2L17 9"
                stroke="#8fae2c"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="status-text">
            <small style={sz(h.screen.statusSmall)}>{txt(h.screen.statusSmall)}</small>
            <strong style={sz(h.screen.statusStrong)}>{txt(h.screen.statusStrong)}</strong>
          </span>
        </div>
        <div className="screen-rows">
          {h.screen.rows.map((row, index) => (
            <div className="screen-row" key={index}>
              <TargetDot />
              <span className="row-label" style={sz(row)}>{txt(row)}</span>
              <span className="row-track">
                <span className="row-fill" style={{ width: `${screenFills[index]}%` }} />
                <span className="row-knob" style={{ left: `${screenFills[index]}%` }} />
              </span>
            </div>
          ))}
        </div>
      </Reveal>

      <div className="hero-cards">
        {h.cards.map((card, index) => (
          <Reveal
            className="hero-card"
            key={index}
            delay={0.15 + index * 0.12}
            y={18}
          >
            <Link
              to={`/services/${card.slug}`}
              className="hero-card-link"
              data-testid={`hero-card-${card.slug}`}
            >
              <span className="hc-icon">
                <ServiceIcon name={cardIcons[index]} />
              </span>
              <div className="hc-text">
                <span className="hc-title" style={sz(card.title)}>{txt(card.title)}</span>
                <span className="hc-sub" style={sz(card.sub)}>{txt(card.sub)}</span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Hero;
